import axiosInstance from "../axios/axiosInstance";
import { trackException } from "../telemetry";

/**
 * Fetches build/runtime metadata plus RequestId header for easy support/debug sharing.
 * Expected response payload shape:
 *  { version, sha, containerRevision, region, timestamp }
 * Some APIs may wrap in { data: ... } so we handle both.
 */
export const fetchBuildInfo = async () => {
  try {
    const response = await axiosInstance.get("/users/buildInfo");
    const payload = response?.data?.data ?? response?.data ?? {};
    return payload;
  } catch (error) {
    trackException(error, { context: "Fetch_Build_Info" });
    throw error;
  }
};


